<template>
  <div class="item-base">
    <div class="item-right" v-if="Tel.photoUrl">
      <img :src="'http://'+Tel.photoUrl" class="img">
      <div class="right-bg">
      </div>
    </div>
    <div class="item-left">
      <div class="item">
        <img src="~assets/service/menu_phone@3x.png" alt="">
        <pre>服务热线：400-0571-819</pre>
      </div>
      <div class="item">
        <img src="~assets/service/qq@3x.png" alt="">
        <pre>QQ：9-3141-4941</pre>
      </div>
      <div class="item">
        <img src="~assets/service/weixin@3x.png" alt="">
        <pre>微信：RipeAV</pre>
      </div>
      <div class="item">
        <img src="~assets/service/menu_maps@3x.png" alt="">
        <pre>邮箱：postmaster@ripeav.com</pre>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ServiceTel",
    created() {
      this.GetData()
    },
    data(){
      return{
        Tel:null,
      }
    },
    methods:{
      async GetData(){
        this.$axios.get('/api/after/getAll').then(res=>{
          this.Tel=res.data.data[1];
          // console.log(this.Tel)
        })
      },
    }
  }
</script>

<style lang="less" scoped>
  .item-base {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .item-left{
      margin-left: 120px;
      display: flex;
      align-items: center;
      width: 657px;
      flex-wrap: wrap;
      justify-content: space-between;
      .item{
        width: 300px;
      }
      img{
        width: 40px;
        height: 40px;
      }
      pre{
        font-size: 24px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #000000;
        line-height: 36px;
      }
    }
    .item-right{
      width: 657px;
      position: relative;

      .img{
        position: relative;
        width: 657px;
        height: 486px;
        z-index: 6;
        object-fit: cover;
      }
      .right-bg{
        width: 679px;
        height: 486px;
        background: #188ACB;
        opacity: 0.5;
        position: absolute;
        top: 40px;
        right: 25px;
        z-index: 1;
      }
    }
  }
</style>